<div class="obg-m-sga-session-limit-header">
	<img obgImageContent="general.session-limit-time" />
	<div>
		<h1>{{ 'multi-session-limit.title' | jurisdiction | translate }}</h1>
		<p>
			{{ 'multi-session-limit.description' | jurisdiction |translate }}
			<a *ngIf="collapseDepositInfo" (click)="navigateToResponsibleGaming()"
				>{{ 'general.read-more' | translate }}</a
			>
		</p>
	</div>
</div>

<div *ngIf="covidMeasuresEnabled" class="covid-message-info">
	<span class="ico-exclamation"></span>
	<p>{{ 'multi-session-limit.covid19-message' | translate }}</p>
</div>

<mat-card>
	<form class="obg-m-sga-session-limit-form" [formGroup]="formService.sessionLimitForm">
		<obg-m-session-limit-item
			[control]="formService.sessionLimitForm.controls.dailySessionLimit"
			[suffix]="daily"
			[autoFocus]="!autoFocusDisabled"
			[hideValidator]="formService.forceInvalidForm"
			[showInputField]="!(hasCurrentLimits$ | async) || showInputFields"
			[placeholder]="formService.placeholder"
			[currentLimitValue]="formService.currentLimits?.dailySessionLimit"
			[hideInputHint]="isJurisdictionSga$ | async"
		>
		</obg-m-session-limit-item>

		<obg-m-session-limit-item
			[control]="formService.sessionLimitForm.controls.weeklySessionLimit"
			[suffix]="weekly"
			[hideValidator]="formService.forceInvalidForm"
			[showInputField]="!(hasCurrentLimits$ | async) || showInputFields"
			[placeholder]="formService.placeholder"
			[currentLimitValue]="formService.currentLimits?.weeklySessionLimit"
			[limitSuggestion]="formService.weeklySuggestion"
			[hideInputHint]="isJurisdictionSga$ | async"
		>
		</obg-m-session-limit-item>

		<obg-m-session-limit-item
			[control]="formService.sessionLimitForm.controls.monthlySessionLimit"
			[suffix]="monthly"
			[hideValidator]="formService.forceInvalidForm"
			[showInputField]="!(hasCurrentLimits$ | async) || showInputFields"
			[placeholder]="formService.placeholder"
			[currentLimitValue]="formService.currentLimits?.monthlySessionLimit"
			[limitSuggestion]="formService.monthlySuggestion"
			[hideInputHint]="isJurisdictionSga$ | async"
		>
		</obg-m-session-limit-item>
	</form>

	<div *ngIf="formService.upcomingLimits" class="obg-m-sga-session-limit-form-upcoming">
		<div *ngIf="formService.upcomingLimits?.dailySessionLimit !== 0; else upcomingLimitsDeleted">
			<label
				class="obg-m-sga-session-limit-upcoming-limit"
				[innerHtml]="'multi-session-limit.upcoming-limit.daily' | jurisdiction | translate: {
				queuedLimit: formService.upcomingLimits?.dailySessionLimit,
				activeFrom: formService.upcomingLimits?.activeFrom | date: 'dd MMMM yyyy'
			}"
			>
			</label>

			<label
				class="obg-m-sga-session-limit-upcoming-limit"
				[innerHtml]="'multi-session-limit.upcoming-limit.weekly' | jurisdiction | translate: {
				queuedLimit: formService.upcomingLimits?.weeklySessionLimit,
				activeFrom: formService.upcomingLimits?.activeFrom | date: 'dd MMMM yyyy'
			}"
			>
			</label>

			<label
				class="obg-m-sga-session-limit-upcoming-limit"
				[innerHtml]="'multi-session-limit.upcoming-limit.monthly' | jurisdiction | translate: {
				queuedLimit: formService.upcomingLimits?.monthlySessionLimit,
				activeFrom: formService.upcomingLimits?.activeFrom | date: 'dd MMMM yyyy'
			}"
			>
			</label>
		</div>

		<ng-template #upcomingLimitsDeleted>
			<label
				class="obg-m-sga-session-limit-upcoming-limit"
				[innerHtml]="'multi-session-limit.upcoming-limit-deletion.daily' | jurisdiction | translate: {
			date: formService.upcomingLimits?.activeFrom | date: 'dd MMMM yyyy'
			}"
			>
			</label>

			<label
				class="obg-m-sga-session-limit-upcoming-limit"
				[innerHtml]="'multi-session-limit.upcoming-limit-deletion.weekly' | jurisdiction | translate: {
				date: formService.upcomingLimits?.activeFrom | date: 'dd MMMM yyyy'
			}"
			>
			</label>

			<label
				class="obg-m-sga-session-limit-upcoming-limit"
				[innerHtml]="'multi-session-limit.upcoming-limit-deletion.monthly' | jurisdiction | translate: {
				date: formService.upcomingLimits?.activeFrom | date: 'dd MMMM yyyy'
			}"
			>
			</label>
		</ng-template>
	</div>

	<div class="btn-container">
		<button
			class="obg-m-sga-session-limit-submit"
			mat-flat-button
			*ngIf="!(hasCurrentLimits$ | async) || showInputFields; else changeSessionLimits"
			color="accent"
			(click)="onSubmit()"
			[disabled]="!formService.sessionLimitForm.valid"
		>
			<mat-spinner *ngIf="isSettingBusy; else showSetLimits" diameter="20"></mat-spinner>
			<ng-template #showSetLimits
				>{{ "multi-session-limit.set-session-time-limits" | jurisdiction | translate }}</ng-template
			>
		</button>
	</div>

	<ng-template #changeSessionLimits>
		<button mat-flat-button color="accent" (click)="toggleInputFields()">
			<mat-spinner *ngIf="isSettingBusy; else showChangeLimits" diameter="20"></mat-spinner>
			<ng-template #showChangeLimits
				>{{ "multi-session-limit.change-session-limit" | jurisdiction | translate }}</ng-template
			>
		</button>

		<button
			*ngIf="!covidMeasuresEnabled && !showInputFields && formService.upcomingLimits?.dailySessionLimit !== 0 && (hasCurrentLimits$ | async)"
			mat-flat-button
			class="remove-limits"
			[disabled]="isRemovingBusy"
			color="primary"
			(click)="onRemove()"
		>
			<mat-spinner *ngIf="isRemovingBusy; else showRemoveLimits" diameter="20"></mat-spinner>
			<ng-template #showRemoveLimits
				>{{ "multi-session-limit.remove.confirmation-title" | jurisdiction | translate }}</ng-template
			>
		</button>
	</ng-template>

	<label class="validation-error" *ngIf="formService.forceInvalidForm"
		>{{ "multi-session-limit.same-" + formService.validationKey + "-session-limit" | jurisdiction | translate
		}}</label
	>
</mat-card>

<div
	*ngIf="!collapseDepositInfo"
	class="caption"
	[innerHtml]="'multi-session-limit.information' | jurisdiction | translate"
></div>
